


























































import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'
import { useCookiePermission } from '~/composables/ui/useCookiePermission'
import { PermissionStatus } from '~/types/common'

export default defineComponent({
  name: 'AppCookiePopup',

  setup() {
    const { visible, getPermissionStatus, open, onAccept, onRefuse } =
      useCookiePermission()

    const shouldAskPermission = ref(false)

    onMounted(() => {
      const permissionStatus = getPermissionStatus()
      if (permissionStatus === PermissionStatus.Prompt) {
        open()
        shouldAskPermission.value = true
      }
    })

    return {
      visible,
      shouldAskPermission,

      open,
      onAccept,
      onRefuse,
    }
  },
})
